<template>
  <div>
    <Header />

    <section
      id="comparer_header"
      class="py-9 px-4 overflow-hidden min-h-[240px]"
    >
      <div
        v-if="this.$store.state.starpacks.length > 0"
        class="relative z-30 max-w-6xl mx-auto"
      >
        <div class="md:w-3/4">
          <h1 class="mb-6 md:text-3xl text-2xl relative z-30 w-[65%] md:w-full">
            Sprawdziliśmy dla Ciebie oferty od 3 towarzystw
          </h1>
          <p class="text-sm w-[65%] md:w-full">
            Mamy dla Ciebie
            <strong>{{ this.$store.state.starpacks.length }} ofert </strong> z
            <strong>{{ groupByCategory.length }} towarzystw</strong>
          </p>
        </div>

        <div
          class="absolute bg-orange-100 rounded-full md:w-64 md:h-64 w-36 h-36 md:right-0 md:-top-20 -top-16 -right-10"
        >
          <img
            class="
              absolute
              bottom-1/2
              right-1/2
              transform
              translate-x-1/2 translate-y-1/2
              w-16
              h-16
              md:h-[90px] md:w-[90px]
            "
            src="@/assets/img/punkta_comparer/podroze.png"
            alt="icon"
          />
        </div>
      </div>
    </section>
    <section
      v-if="getOnPodium($store.state.starpacks)"
      id="comparer_form"
      class="px-4 pt-16 overflow-hidden bg-gray-100"
    >
      <div class="max-w-6xl mx-auto">
        <div class="md:mx-[-10px] flex flex-wrap">
          <div
            v-for="(podium, index) in getOnPodium($store.state.starpacks)"
            :key="index"
            class="md:px-[10px] md:w-1/3 w-full mb-14"
          >
            <div
              v-if="podium.lowPrice"
              class="flex justify-center w-3/5 py-2 mx-auto bg-orange-100 rounded-t "
            >
              <div class="uppercase text-white text-[10px] mx-1 font-bold">
                niska cena
              </div>
            </div>
            <div
              v-if="podium.hitThePoint"
              class="flex justify-center w-3/5 py-2 mx-auto bg-red-100 rounded-t "
            >
              <div class="uppercase text-white text-[10px] mx-1 font-bold">
                trafiona w punkt
              </div>
            </div>
            <div
              v-if="podium.forTheDemanding"
              class="flex justify-center w-3/5 py-2 mx-auto bg-blue-100 rounded-t "
            >
              <div class="uppercase text-white text-[10px] mx-1 font-bold">
                dla wymagających
              </div>
            </div>
            <div
              class=" py-5 bg-white rounded-lg shadow-0-2-5 px-4 md:min-h-[428px]"
            >
              <div class="flex flex-col justify-between">
                <div class="w-full" style="flex: 1">
                  <div class="flex justify-between mb-8">
                    <img
                      v-if="podium.logo"
                      :src="podium.logo"
                      alt="logo"
                      style="height: 40px;"
                    />
                    <div class="self-center text-xs">
                      Oferta nr.: <strong>{{ podium.id_starpack }}</strong>
                    </div>
                  </div>
                  <div
                    v-if="podium.result_info.main_products.length > 0"
                    class="flex flex-wrap justify-center  mt-4"
                  >
                    <div
                      v-for="packageOffer in filterGreenDots(
                        podium.result_info.main_products
                      )"
                      :key="packageOffer.id_starpack"
                      class="px-1 md:w-[105px] w-[90px] mb-5"
                    >
                      <div
                        class="relative w-8 h-8 mx-auto mb-1  rounded-full "
                        :class="
                          packageOffer.active ? 'bg-green-100' : 'bg-gray-100'
                        "
                      >
                        <img
                          class="absolute transform -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2"
                          :src="
                            packageOffer.active
                              ? require('@/assets/img/punkta_comparer/tickmark.svg')
                              : require('@/assets/img/punkta_comparer/x-mark.svg')
                          "
                          alt="tickmark"
                        />
                      </div>
                      <div class="text-xs font-medium text-center">
                        {{ packageOffer.text }}
                        <br />
                        {{ packageOffer.value }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="w-full" style="flex: 1">
                  <div
                    v-if="podium.price"
                    class="text-center text-[28px] font-medium"
                  >
                    {{ replacePrice(podium.price) }} zł
                  </div>
                  <div
                    v-if="podium.day_amount"
                    class="flex items-center justify-center mb-2"
                  >
                    <div class="text-xs font-medium text-black text-opacity-60">
                      {{ podium.day_amount }} zł / za dzień
                    </div>
                  </div>

                  <div
                    v-on:click="getAddresses(podium, true)"
                    class="
                    cursor-pointer
    comparer-button
    bg-orange-100
    font-bold
    text-white text-xs
    py-4
    rounded-lg
    w-[70%]
    flex
    justify-center
    mx-auto
    mb-2
  "
                  >
                    <div class="mx-1">Kup online</div>
                    <svg
                      class="self-center mx-1"
                      width="15"
                      height="6"
                      viewBox="0 0 15 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.9437 2.67401C14.908 2.56895 14.8545 2.47296 14.7862 2.39156L12.9107 0.251722C12.7695 0.0905471 12.5779 0 12.3781 0C12.1783 0 11.9867 0.0905471 11.8455 0.251722C11.7042 0.412898 11.6248 0.631499 11.6248 0.859435C11.6248 1.08737 11.7042 1.30597 11.8455 1.46715L12.4456 2.14334H0.750187C0.551225 2.14334 0.360412 2.23351 0.219725 2.39403C0.0790375 2.55455 0 2.77226 0 2.99927C0 3.22628 0.0790375 3.44399 0.219725 3.6045C0.360412 3.76502 0.551225 3.8552 0.750187 3.8552H12.4456L11.8455 4.53139C11.7751 4.61096 11.7193 4.70563 11.6812 4.80993C11.6432 4.91423 11.6236 5.02611 11.6236 5.1391C11.6236 5.2521 11.6432 5.36397 11.6812 5.46827C11.7193 5.57258 11.7751 5.66724 11.8455 5.74681C11.9152 5.82704 11.9982 5.89072 12.0896 5.93417C12.181 5.97763 12.2791 6 12.3781 6C12.4771 6 12.5752 5.97763 12.6666 5.93417C12.758 5.89072 12.841 5.82704 12.9107 5.74681L14.7862 3.60698C14.8545 3.52558 14.908 3.42959 14.9437 3.32452C15.0188 3.11614 15.0188 2.8824 14.9437 2.67401Z"
                        fill="white"
                      />
                    </svg>
                  </div>

                  <div
                    v-on:click="setActive"
                    class="relative  cursor-pointer inline-flex items-center justify-center transform -translate-x-1/2 show-details left-1/2"
                  >
                    <div class="text-xs font-medium text-black text-opacity-60">
                      Szczegóły oferty
                    </div>
                    <img
                      class="ml-1"
                      src="@/assets/img/punkta_comparer/doublearrow-down.svg"
                      alt="question"
                    />
                  </div>
                </div>
                <div class="hidden mt-4">
                  <div v-if="podium.result_info.main_products" class="md:-mx-4">
                    <div class="text-xs md:px-4">
                      <div
                        class="mb-4"
                        v-for="(product, index) in filterMainProducts(
                          podium.result_info.main_products,
                          'odd'
                        )"
                        :key="index"
                      >
                        <div
                          class="py-1 mb-2 font-medium text-center bg-gray-100 rounded "
                        >
                          {{ product.name }}
                        </div>
                        <ul
                          v-if="product.subcategories.length > 0"
                          class="list-none"
                        >
                          <li
                            v-for="(subcategory, index) in filterSubcategories(
                              product.subcategories
                            )"
                            :key="index"
                            class="flex justify-between mb-1"
                          >
                            <div class="w-10/12">{{ subcategory.name }}</div>
                            <div class="w-2/12 font-medium text-right">
                              {{
                                subcategory.value !== '1'
                                  ? subcategory.value
                                  : ''
                              }}
                              {{ subcategory.value === '1' ? 'TAK' : '' }}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="text-xs  md:px-4">
                      <div
                        class="mb-4"
                        v-for="(product, index) in filterMainProducts(
                          podium.result_info.main_products,
                          'even'
                        )"
                        :key="index"
                      >
                        <div
                          class="py-1 mb-2 font-medium text-center bg-gray-100 rounded "
                        >
                          {{ product.name }}
                        </div>
                        <ul
                          v-if="product.subcategories.length > 0"
                          class="list-none"
                        >
                          <li
                            v-for="(subcategory, index) in filterSubcategories(
                              product.subcategories
                            )"
                            :key="index"
                            class="flex justify-between mb-1"
                          >
                            <div class="w-10/12">{{ subcategory.name }}</div>
                            <div class="w-2/12 font-medium text-right">
                              {{
                                subcategory.value !== '1'
                                  ? subcategory.value
                                  : ''
                              }}
                              {{ subcategory.value === '1' ? 'TAK' : '' }}
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div
                        v-if="
                          podium.result_info &&
                            (podium.result_info.product_card ||
                              podium.result_info.owu)
                        "
                      >
                        <div
                          class="py-1 mb-2 font-medium text-center bg-gray-100 rounded "
                        >
                          Dokumenty do pobrania
                        </div>
                        <ul class="font-medium list-none">
                          <li
                            v-if="podium.result_info.product_card"
                            class="mb-1"
                          >
                            <a
                              :href="podium.result_info.product_card"
                              target="_blank"
                              class="flex justify-end"
                            >
                              <svg
                                width="16"
                                height="17"
                                viewBox="0 0 16 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M13.3327 6.33283C13.3257 6.26775 13.3123 6.20365 13.2927 6.14158V6.07783C13.2606 6.00499 13.2179 5.93805 13.166 5.87949L9.16602 1.62949C9.11091 1.5744 9.0479 1.52897 8.97935 1.49491H8.91935L8.70602 1.41699H4.66602C4.13558 1.41699 3.62687 1.64088 3.2518 2.03939C2.87673 2.43791 2.66602 2.97841 2.66602 3.54199V13.4587C2.66602 14.0222 2.87673 14.5627 3.2518 14.9613C3.62687 15.3598 4.13558 15.5837 4.66602 15.5837H11.3327C11.8631 15.5837 12.3718 15.3598 12.7469 14.9613C13.122 14.5627 13.3327 14.0222 13.3327 13.4587V6.37533C13.3327 6.37533 13.3327 6.37533 13.3327 6.33283ZM9.33268 3.83241L11.0593 5.66699H9.33268V3.83241ZM11.9993 13.4587C11.9993 13.6465 11.9291 13.8267 11.8041 13.9595C11.6791 14.0924 11.5095 14.167 11.3327 14.167H4.66602C4.4892 14.167 4.31964 14.0924 4.19461 13.9595C4.06959 13.8267 3.99935 13.6465 3.99935 13.4587V3.54199C3.99935 3.35413 4.06959 3.17396 4.19461 3.04113C4.31964 2.90829 4.4892 2.83366 4.66602 2.83366H7.99935V6.37533C7.99935 6.56319 8.06959 6.74335 8.19461 6.87619C8.31963 7.00903 8.4892 7.08366 8.66602 7.08366H11.9993V13.4587Z"
                                  fill="black"
                                />
                              </svg>
                              <div class="ml-1 underline">
                                Karta Produktu.pdf
                              </div>
                            </a>
                          </li>
                          <li v-if="podium.result_info.owu" class="mb-1">
                            <a
                              :href="podium.result_info.owu"
                              target="_blank"
                              class="flex justify-end"
                            >
                              <svg
                                width="16"
                                height="17"
                                viewBox="0 0 16 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M13.3327 6.33283C13.3257 6.26775 13.3123 6.20365 13.2927 6.14158V6.07783C13.2606 6.00499 13.2179 5.93805 13.166 5.87949L9.16602 1.62949C9.11091 1.5744 9.0479 1.52897 8.97935 1.49491H8.91935L8.70602 1.41699H4.66602C4.13558 1.41699 3.62687 1.64088 3.2518 2.03939C2.87673 2.43791 2.66602 2.97841 2.66602 3.54199V13.4587C2.66602 14.0222 2.87673 14.5627 3.2518 14.9613C3.62687 15.3598 4.13558 15.5837 4.66602 15.5837H11.3327C11.8631 15.5837 12.3718 15.3598 12.7469 14.9613C13.122 14.5627 13.3327 14.0222 13.3327 13.4587V6.37533C13.3327 6.37533 13.3327 6.37533 13.3327 6.33283ZM9.33268 3.83241L11.0593 5.66699H9.33268V3.83241ZM11.9993 13.4587C11.9993 13.6465 11.9291 13.8267 11.8041 13.9595C11.6791 14.0924 11.5095 14.167 11.3327 14.167H4.66602C4.4892 14.167 4.31964 14.0924 4.19461 13.9595C4.06959 13.8267 3.99935 13.6465 3.99935 13.4587V3.54199C3.99935 3.35413 4.06959 3.17396 4.19461 3.04113C4.31964 2.90829 4.4892 2.83366 4.66602 2.83366H7.99935V6.37533C7.99935 6.56319 8.06959 6.74335 8.19461 6.87619C8.31963 7.00903 8.4892 7.08366 8.66602 7.08366H11.9993V13.4587Z"
                                  fill="black"
                                />
                              </svg>
                              <div class="ml-1 underline">
                                OWU.pdf
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <section class="hidden px-4 py-10 overflow-hidden bg-white md:block">
      <div class="max-w-6xl mx-auto">
        <div class="flex justify-between mb-5">
          <h2 class="text-[26px]">Lista ofert</h2>
          <div class="flex">
            <div
              class="
                border border-black border-opacity-20
                rounded-lg
                min-w
                w-12
                h-12
                text-center
                relative
                mx-[5px]
              "
            >
              <span
                class="absolute text-xs text-black transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 text-opacity-60"
                >?</span
              >
            </div>

            <div
              class="
                border border-black border-opacity-20
                rounded-lg
                w-12
                h-12
                text-center
                relative
                mx-[5px]
              "
            >
              <span
                class="absolute text-xs text-black transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 text-opacity-60"
                >?</span
              >
            </div>

            <div
              class="
                border border-black border-opacity-20
                rounded-lg
                w-12
                h-12
                text-center
                relative
                mx-[5px]
              "
            >
              <span
                class="absolute text-xs text-black transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 text-opacity-60"
                >NNW</span
              >
            </div>

            <div
              class="
                border border-black border-opacity-20
                rounded-lg
                w-12
                h-12
                text-center
                relative
                mx-[5px]
              "
            >
              <span
                class="absolute text-xs text-black transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 text-opacity-60"
                >?</span
              >
            </div>
          </div>
        </div>
        <div class="md:mx-[-10px] flex flex-wrap">
          <div class="md:w-1/4 md:px-[10px]">
            <h3 class="mb-2 text-xs font-bold text-black text-opacity-60">
              Towarzystwa ubezpieczeniowe
            </h3>
            <select
              class="w-full p-4 text-xs font-medium text-black bg-white border border-black rounded-lg border-opacity-20 text-opacity-60"
              name=""
              id=""
            >
              <option value="">Wszystkie</option>
              <option value="1">Test</option>
              <option value="2">Test2</option>
              <option value="3">Test3</option>
              <option value="4">Test4</option>
            </select>
          </div>

          <div class="md:w-1/4 md:px-[10px]">
            <h3 class="mb-2 text-xs font-bold text-black text-opacity-60">
              Towarzystwa ubezpieczeniowe
            </h3>
            <select
              class="w-full p-4 text-xs font-medium text-black bg-white border border-black rounded-lg border-opacity-20 text-opacity-60"
              name=""
              id=""
            >
              <option value="">Wszystkie</option>
              <option value="1">Test</option>
              <option value="2">Test2</option>
              <option value="3">Test3</option>
              <option value="4">Test4</option>
            </select>
          </div>

          <div class="md:w-1/4 md:px-[10px]">
            <h3 class="mb-2 text-xs font-bold text-black text-opacity-60">
              Towarzystwa ubezpieczeniowe
            </h3>
            <select
              class="w-full p-4 text-xs font-medium text-black bg-white border border-black rounded-lg border-opacity-20 text-opacity-60"
              name=""
              id=""
            >
              <option value="">Wszystkie</option>
              <option value="1">Test</option>
              <option value="2">Test2</option>
              <option value="3">Test3</option>
              <option value="4">Test4</option>
            </select>
          </div>

          <div class="md:w-1/4 md:px-[10px]">
            <h3 class="mb-2 text-xs font-bold text-black text-opacity-60">
              Towarzystwa ubezpieczeniowe
            </h3>
            <select
              class="w-full p-4 text-xs font-medium text-black bg-white border border-black rounded-lg border-opacity-20 text-opacity-60"
              name=""
              id=""
            >
              <option value="">Wszystkie</option>
              <option value="1">Test</option>
              <option value="2">Test2</option>
              <option value="3">Test3</option>
              <option value="4">Test4</option>
            </select>
          </div>
        </div>
      </div>
    </section> -->
    <section class="px-4 pb-40 overflow-hidden bg-gray-100 pt-14">
      <div class="max-w-6xl mx-auto">
        <!-- <h2 class="mb-16 text-[26px]">Pozostałe oferty</h2> -->
        <div class="flex md:mx-[-10px]">
          <div
            v-if="this.$store.state.starpacks.length > 0"
            class="md:w-3/4 md:px-[10px]"
          >
            <div
              v-for="(item, index) in this.$store.state.starpacks"
              :key="item.id_starpack + '_' + index"
              class="w-full mb-8"
            >
              <div class="flex justify-between">
                <div
                  v-if="item.logo"
                  class="px-4 py-5 bg-white rounded-t-lg"
                  style="box-shadow: 0px -4px 5px rgba(0, 0, 0, 0.2)"
                >
                  <img :src="item.logo" alt="logo" style="height: 40px;" />
                </div>
                <div
                  v-if="item.id_starpack === listingLowPrice"
                  class="mr-5 rounded-t bg-orange-100 w-40 py-2 uppercase text-white text-[10px] font-bold self-end text-center"
                >
                  niska cena
                </div>
                <div
                  v-if="item.id_starpack === listingHitThePoint"
                  class="mr-5 rounded-t bg-red-100 w-40 py-2 uppercase text-white text-[10px] font-bold self-end text-center"
                >
                  trafiona w punkt
                </div>
                <div
                  v-if="item.id_starpack === listingForTheDemanding"
                  class="mr-5 rounded-t bg-blue-100 w-40 py-2 uppercase text-white text-[10px] font-bold self-end text-center"
                >
                  dla wymagających
                </div>
              </div>
              <div
                class="px-5 bg-white rounded-b-lg rounded-r-lg shadow-0-2-5 py-5 md:py-7"
              >
                <div class="flex flex-wrap justify-center md:justify-between">
                  <div>
                    <!-- <h2
                      v-if="item.result_info && item.result_info.name"
                      class="mb-4 text-3xl font-medium text-center md:text-left"
                    >
                     {{item.result_info.name }}
                    </h2> -->
                    <h3
                      class="mb-4 text-lg font-medium text-center md:text-left"
                    >
                      Oferta nr.: {{ item.id_starpack }}
                    </h3>
                    <div
                      v-if="item.result_info.main_products.length > 0"
                      class="flex flex-wrap justify-center md:-mx-1 md:justify-start"
                    >
                      <div
                        v-for="packageOffer in filterGreenDots(
                          item.result_info.main_products
                        )"
                        :key="packageOffer.id_starpack"
                        class="px-1 w-[90px] mb-5"
                      >
                        <div
                          class="relative w-8 h-8 mx-auto mb-1  rounded-full "
                          :class="
                            packageOffer.active ? 'bg-green-100' : 'bg-gray-100'
                          "
                        >
                          <img
                            class="absolute transform -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2"
                            :src="
                              packageOffer.active
                                ? require('@/assets/img/punkta_comparer/tickmark.svg')
                                : require('@/assets/img/punkta_comparer/x-mark.svg')
                            "
                            alt="tickmark"
                          />
                        </div>
                        <div class="text-xs font-medium text-center">
                          {{ packageOffer.text }}
                          <br />
                          {{ packageOffer.value }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <h3
                      v-if="item.price"
                      class="mb-1 text-2xl font-medium text-center"
                    >
                      {{ replacePrice(item.price) }} zł
                    </h3>
                    <h4
                      v-if="item.day_amount"
                      class="mb-2 text-xs font-medium text-center text-black text-opacity-60"
                    >
                      {{ item.day_amount }} zł / za dzień
                    </h4>

                    <div
                      v-on:click="getAddresses(item, false)"
                      class="flex cursor-pointer justify-center w-40 py-4 mx-auto mb-2 text-xs font-bold text-white bg-orange-100 rounded-lg comparer-button"
                    >
                      <div class="mx-1">Kup online</div>
                      <svg
                        class="self-center mx-1"
                        width="15"
                        height="6"
                        viewBox="0 0 15 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.9437 2.67401C14.908 2.56895 14.8545 2.47296 14.7862 2.39156L12.9107 0.251722C12.7695 0.0905471 12.5779 0 12.3781 0C12.1783 0 11.9867 0.0905471 11.8455 0.251722C11.7042 0.412898 11.6248 0.631499 11.6248 0.859435C11.6248 1.08737 11.7042 1.30597 11.8455 1.46715L12.4456 2.14334H0.750187C0.551225 2.14334 0.360412 2.23351 0.219725 2.39403C0.0790375 2.55455 0 2.77226 0 2.99927C0 3.22628 0.0790375 3.44399 0.219725 3.6045C0.360412 3.76502 0.551225 3.8552 0.750187 3.8552H12.4456L11.8455 4.53139C11.7751 4.61096 11.7193 4.70563 11.6812 4.80993C11.6432 4.91423 11.6236 5.02611 11.6236 5.1391C11.6236 5.2521 11.6432 5.36397 11.6812 5.46827C11.7193 5.57258 11.7751 5.66724 11.8455 5.74681C11.9152 5.82704 11.9982 5.89072 12.0896 5.93417C12.181 5.97763 12.2791 6 12.3781 6C12.4771 6 12.5752 5.97763 12.6666 5.93417C12.758 5.89072 12.841 5.82704 12.9107 5.74681L14.7862 3.60698C14.8545 3.52558 14.908 3.42959 14.9437 3.32452C15.0188 3.11614 15.0188 2.8824 14.9437 2.67401Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                <div
                  class="flex justify-center  w-full px-2 pt-2 md:mb-5 md:bg-gray-100 rounded-t-lg md:justify-between"
                >
                  <div
                    class="
    text-[11px] text-black text-opacity-60
    font-bold
    hidden
    md:block
  "
                  >
                    <div
                      v-if="
                        filterRangeOffers(item.result_info.main_products)
                          .length > 0
                      "
                      class="mb-2"
                    >
                      Dodatki:&nbsp;
                      <span
                        v-for="(product, index) in filterRangeOffers(
                          item.result_info.main_products
                        )"
                        :key="index"
                      >
                        {{
                          product.name +
                            (filterRangeOffers(item.result_info.main_products)
                              .length ===
                            index + 1
                              ? ''
                              : ', ')
                        }}
                      </span>
                    </div>
                  </div>
                  <div
                    v-on:click="setActive"
                    class="flex items-center mb-2 show-details cursor-pointer"
                  >
                    <div
                      class="text-xs font-medium md:text-opacity-100 text-opacity-60 text-black w-max"
                    >
                      Szczegóły oferty
                    </div>
                    <img
                      src="@/assets/img/punkta_comparer/doublearrow-down.svg"
                      alt="arrow"
                    />
                  </div>
                </div>
                <div class="hidden">
                  <div
                    v-if="item.result_info.main_products"
                    class="md:-mx-4 md:flex"
                  >
                    <div class="text-xs md:w-1/2 md:px-4">
                      <div
                        class="mb-4"
                        v-for="(product, index) in filterMainProducts(
                          item.result_info.main_products,
                          'odd'
                        )"
                        :key="index"
                      >
                        <div
                          class="py-1 mb-2 font-medium text-center bg-gray-100 rounded "
                        >
                          {{ product.name }}
                        </div>
                        <ul
                          v-if="product.subcategories.length > 0"
                          class="list-none"
                        >
                          <li
                            v-for="(subcategory, index) in filterSubcategories(
                              product.subcategories
                            )"
                            :key="index"
                            class="flex justify-between mb-1"
                          >
                            <div class="w-10/12">{{ subcategory.name }}</div>
                            <div class="w-2/12 font-medium text-right">
                              {{
                                subcategory.value !== '1'
                                  ? subcategory.value
                                  : ''
                              }}
                              {{ subcategory.value === '1' ? 'TAK' : '' }}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="text-xs md:w-1/2 md:px-4">
                      <div
                        class="mb-4"
                        v-for="(product, index) in filterMainProducts(
                          item.result_info.main_products,
                          'even'
                        )"
                        :key="index"
                      >
                        <div
                          class="py-1 mb-2 font-medium text-center bg-gray-100 rounded "
                        >
                          {{ product.name }}
                        </div>
                        <ul
                          v-if="product.subcategories.length > 0"
                          class="list-none"
                        >
                          <li
                            v-for="(subcategory, index) in filterSubcategories(
                              product.subcategories
                            )"
                            :key="index"
                            class="flex justify-between mb-1"
                          >
                            <div class="w-10/12">{{ subcategory.name }}</div>
                            <div class="w-2/12 font-medium text-right">
                              {{
                                subcategory.value !== '1'
                                  ? subcategory.value
                                  : ''
                              }}
                              {{ subcategory.value === '1' ? 'TAK' : '' }}
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div
                        v-if="
                          item.result_info &&
                            (item.result_info.product_card ||
                              item.result_info.owu)
                        "
                      >
                        <div
                          class="py-1 mb-2 font-medium text-center bg-gray-100 rounded "
                        >
                          Dokumenty do pobrania
                        </div>
                        <ul class="font-medium list-none">
                          <li v-if="item.result_info.product_card" class="mb-1">
                            <a
                              :href="item.result_info.product_card"
                              target="_blank"
                              class="flex justify-end"
                            >
                              <svg
                                width="16"
                                height="17"
                                viewBox="0 0 16 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M13.3327 6.33283C13.3257 6.26775 13.3123 6.20365 13.2927 6.14158V6.07783C13.2606 6.00499 13.2179 5.93805 13.166 5.87949L9.16602 1.62949C9.11091 1.5744 9.0479 1.52897 8.97935 1.49491H8.91935L8.70602 1.41699H4.66602C4.13558 1.41699 3.62687 1.64088 3.2518 2.03939C2.87673 2.43791 2.66602 2.97841 2.66602 3.54199V13.4587C2.66602 14.0222 2.87673 14.5627 3.2518 14.9613C3.62687 15.3598 4.13558 15.5837 4.66602 15.5837H11.3327C11.8631 15.5837 12.3718 15.3598 12.7469 14.9613C13.122 14.5627 13.3327 14.0222 13.3327 13.4587V6.37533C13.3327 6.37533 13.3327 6.37533 13.3327 6.33283ZM9.33268 3.83241L11.0593 5.66699H9.33268V3.83241ZM11.9993 13.4587C11.9993 13.6465 11.9291 13.8267 11.8041 13.9595C11.6791 14.0924 11.5095 14.167 11.3327 14.167H4.66602C4.4892 14.167 4.31964 14.0924 4.19461 13.9595C4.06959 13.8267 3.99935 13.6465 3.99935 13.4587V3.54199C3.99935 3.35413 4.06959 3.17396 4.19461 3.04113C4.31964 2.90829 4.4892 2.83366 4.66602 2.83366H7.99935V6.37533C7.99935 6.56319 8.06959 6.74335 8.19461 6.87619C8.31963 7.00903 8.4892 7.08366 8.66602 7.08366H11.9993V13.4587Z"
                                  fill="black"
                                />
                              </svg>
                              <div class="ml-1 underline">
                                Karta Produktu.pdf
                              </div>
                            </a>
                          </li>
                          <li v-if="item.result_info.owu" class="mb-1">
                            <a
                              :href="item.result_info.owu"
                              target="_blank"
                              class="flex justify-end"
                            >
                              <svg
                                width="16"
                                height="17"
                                viewBox="0 0 16 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M13.3327 6.33283C13.3257 6.26775 13.3123 6.20365 13.2927 6.14158V6.07783C13.2606 6.00499 13.2179 5.93805 13.166 5.87949L9.16602 1.62949C9.11091 1.5744 9.0479 1.52897 8.97935 1.49491H8.91935L8.70602 1.41699H4.66602C4.13558 1.41699 3.62687 1.64088 3.2518 2.03939C2.87673 2.43791 2.66602 2.97841 2.66602 3.54199V13.4587C2.66602 14.0222 2.87673 14.5627 3.2518 14.9613C3.62687 15.3598 4.13558 15.5837 4.66602 15.5837H11.3327C11.8631 15.5837 12.3718 15.3598 12.7469 14.9613C13.122 14.5627 13.3327 14.0222 13.3327 13.4587V6.37533C13.3327 6.37533 13.3327 6.37533 13.3327 6.33283ZM9.33268 3.83241L11.0593 5.66699H9.33268V3.83241ZM11.9993 13.4587C11.9993 13.6465 11.9291 13.8267 11.8041 13.9595C11.6791 14.0924 11.5095 14.167 11.3327 14.167H4.66602C4.4892 14.167 4.31964 14.0924 4.19461 13.9595C4.06959 13.8267 3.99935 13.6465 3.99935 13.4587V3.54199C3.99935 3.35413 4.06959 3.17396 4.19461 3.04113C4.31964 2.90829 4.4892 2.83366 4.66602 2.83366H7.99935V6.37533C7.99935 6.56319 8.06959 6.74335 8.19461 6.87619C8.31963 7.00903 8.4892 7.08366 8.66602 7.08366H11.9993V13.4587Z"
                                  fill="black"
                                />
                              </svg>
                              <div class="ml-1 underline">
                                OWU.pdf
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="md:flex">
              <div class="flex justify-between w-full">
                <router-link
                  to="/form-step-2"
                  class="flex justify-center w-32 py-4 text-xs font-bold text-black border border-black rounded-lg comparer-button text-opacity-60 border-opacity-20 md:w-40"
                >
                  <svg
                    class="self-center mx-1 svg-button"
                    width="16"
                    height="6"
                    viewBox="0 0 16 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.556272 3.32599C0.591976 3.43105 0.645515 3.52704 0.713812 3.60844L2.58928 5.74828C2.73054 5.90945 2.92214 6 3.12191 6C3.32169 6 3.51328 5.90945 3.65454 5.74828C3.79581 5.5871 3.87517 5.3685 3.87517 5.14056C3.87517 4.91263 3.79581 4.69403 3.65454 4.53285L3.05439 3.85666L14.7498 3.85666C14.9488 3.85666 15.1396 3.76649 15.2803 3.60597C15.421 3.44545 15.5 3.22774 15.5 3.00073C15.5 2.77372 15.421 2.55601 15.2803 2.3955C15.1396 2.23498 14.9488 2.1448 14.7498 2.1448L3.0544 2.1448L3.65454 1.46861C3.72486 1.38904 3.78067 1.29437 3.81876 1.19007C3.85684 1.08577 3.87645 0.973891 3.87645 0.860897C3.87645 0.747904 3.85684 0.636029 3.81876 0.531725C3.78067 0.427422 3.72486 0.332755 3.65454 0.253185C3.58481 0.172959 3.50183 0.109283 3.41042 0.0658282C3.319 0.0223736 3.22095 8.3388e-07 3.12191 8.25222e-07C3.02288 8.16564e-07 2.92483 0.0223735 2.83341 0.0658282C2.74199 0.109283 2.65902 0.172959 2.58928 0.253185L0.713812 2.39302C0.645515 2.47442 0.591976 2.57041 0.556272 2.67548C0.48124 2.88386 0.48124 3.1176 0.556272 3.32599Z"
                      fill="black"
                    />
                  </svg>
                  <div class="mx-1">Wstecz</div>
                </router-link>
              </div>
            </div>
          </div>

          <Chat />
        </div>
      </div>
    </section>
    <div v-if="loader" class="loader-box">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Chat from './components/Chat.vue'

export default {
  components: {
    Header,
    Chat
  },
  data () {
    return {
      offers: [
        {
          id: '5678a245',
          logo:
            'https://punkta.pl/wp-content/plugins/mfind-comparer/uploads/2/lp-proama.png',
          price: '1358,76',
          range_offer: [
            {
              name: 'treatment_costs_up_to'
            },
            {
              name: 'NNW'
            },
            {
              name: 'OC_in_private_life'
            },
            {
              name: 'luggage'
            },
            {
              name: 'FIT_TRAVEL_PUNKTA_CHRONIC_DISEASES'
            },
            {
              name: 'alcohol_clause'
            }
          ]
        }
      ],
      mainPackages: [
        {
          code: 'LA',
          text: 'Koszty leczenia',
          default: false
        },
        {
          code: 'NNW',
          text: 'NNW',
          default: false
        },
        {
          code: 'OC',
          text: 'OC w życiu prywatnym',
          default: false
        },
        {
          code: 'BG',
          text: 'Bagaż',
          default: false
        },
        {
          code: 'CHP',
          text: 'Choroby przewlekłe',
          default: false
        },
        {
          code: 'KA',
          text: 'Klauzula alkoholowa',
          default: false
        }
      ],
      loader: false,
      showDetails: false,
      groupByCategory: 0,
      listingLowPrice: '',
      listingForTheDemanding: '',
      listingHitThePoint: ''
    }
  },

  mounted () {
    window.scrollTo(0, 0)
    this.$store.commit('setStep', 2)
    this.groupByCategory = this.getGroupByCategory(this.$store.state.starpacks)
    this.formatStarpacksEvent(this.$store.state.starpacks)
  },
  methods: {
    filterRangeOffers (main_products) {
      var tmpArray = []
      var counter = 1
      main_products.forEach(product => {
        if (counter <= 3) {
          if (product.code === 'ASZ') {
            tmpArray.push({
              name: 'Sporty zimowe',
              sort: 1
            })
            counter++
          } else if (product.code === 'ASE') {
            tmpArray.push({
              name: 'Sporty ekstremalne',
              sort: 2
            })
            counter++
          } else if (product.code === 'ASWR') {
            tmpArray.push({
              name: 'Sporty wysokiego ryzyka',
              sort: 3
            })
            counter++
          } else if (product.code === 'WUW') {
            tmpArray.push({
              name: 'Brak udziału własnego w rent a car',
              sort: 4
            })
            counter++
          } else if (product.code === 'PF') {
            tmpArray.push({
              name: 'Praca fizyczna',
              sort: 5
            })
            counter++
          }
        }
      })
      tmpArray.sort(function (a, b) {
        return parseInt(a.sort) - parseInt(b.sort)
      })
      return tmpArray
    },
    filterGreenDots (main_products) {
      var tmpArray = []
      this.mainPackages.forEach(element => {
        var hasMatch = null
        var value_sum = ''

        main_products.forEach(product => {
          if (product.code === element.code) {
            hasMatch = product
            product.subcategories.forEach(subcategory => {
              if (subcategory.code === 'SUM') {
                value_sum = subcategory.value
              }

              if (subcategory.code === 'SUM' && product.code === 'LA') {
                value_sum = this.formatPrice(value_sum)
              }
            })
          }
        })

        tmpArray.push({
          active: hasMatch ? true : false,
          code: element.code,
          text: element.text,
          value: value_sum
        })
      })
      return tmpArray
    },
    formatPrice (price) {
      var tmp = price

      if (price % 1 === 0) {
        if (price >= 1000000) {
          tmp = (price / 1000000).toString().replace('.', ',') + 'mln zł'
        } else {
          tmp = this.formatNumber(price) + ' zł'
        }
      }

      return tmp
    },
    formatNumber (number) {
      number = number + ''
      var x = number.split('.')
      var x1 = x[0]
      var x2 = x.length > 1 ? '.' + x[1] : ''
      var rgx = /(\d+)(\d{3})/
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + '.' + '$2')
      }
      return x1 + x2
    },
    getGroupByCategory (starpacks) {
      return this.groupBy(starpacks)
    },
    groupBy (array) {
      let result = []
      array.forEach(item => {
        let tuName = item?.result_info?.name
        if (!result.includes(tuName)) {
          result.push(tuName)
        }
      })
      return result
    },
    getOnPodium (starpacks) {
      var tmpArray = []
      var getLowPrice = this.getLowPrice(starpacks)
      var getForTheDemanding = this.getForTheDemanding(starpacks, [
        getLowPrice?.id_starpack
      ])
      var getHitThePoint = this.getHitThePoint(starpacks, [
        getLowPrice?.id_starpack,
        getForTheDemanding?.id_starpack
      ])

      if (getLowPrice) {
        getLowPrice.lowPrice = true
        this.listingLowPrice = getLowPrice?.id_starpack
        tmpArray.push(getLowPrice)
      }

      if (getForTheDemanding) {
        getForTheDemanding.forTheDemanding = true
        this.listingForTheDemanding = getForTheDemanding?.id_starpack
        tmpArray.push(getForTheDemanding)
      }

      if (getHitThePoint) {
        getHitThePoint.hitThePoint = true
        this.listingHitThePoint = getHitThePoint?.id_starpack
        tmpArray.push(getHitThePoint)
      }

      return tmpArray
    },
    getLowPrice (starpacks) {
      var tmpArray = []
      starpacks.forEach(starpack => {
        var counter = 1
        starpack?.result_info?.main_products.forEach(main_product => {
          switch (main_product.code) {
            case 'KA':
              counter++
              break
            default:
              break
          }
        })
        if (counter === 2) {
          tmpArray.push(starpack)
        }
      })
      tmpArray.sort(function (a, b) {
        return parseFloat(a.price) - parseFloat(b.price)
      })

      return tmpArray.length > 0 ? tmpArray[0] : false
    },
    getHitThePoint (starpacks, disableStarpacks) {
      var tmpArray = []
      var tmpStarpacks = []
      starpacks.forEach(starpack => {
        if (!disableStarpacks.includes(starpack.id_starpack)) {
          var counter = 1
          starpack?.result_info?.main_products.forEach(main_product => {
            switch (main_product.code) {
              case 'KA':
                counter++
                break
              default:
                break
            }
          })
          if (counter === 2) {
            tmpArray.push(starpack)
          }
        }
      })

      tmpArray.forEach(element => {
        element?.result_info?.main_products.forEach(main_product => {
          main_product.subcategories.forEach(subcategory => {
            if (subcategory.code === 'SUM' && main_product.code === 'LA') {
              if (
                subcategory.value % 1 === 0 &&
                subcategory.value > 100000 &&
                subcategory.value <= 250000
              ) {
                tmpStarpacks.push(element)
              }
            }
          })
        })
      })

      tmpStarpacks.sort(function (a, b) {
        return parseFloat(a.price) - parseFloat(b.price)
      })

      return tmpStarpacks.length > 0 ? tmpStarpacks[0] : false
    },
    getForTheDemanding (starpacks, disableStarpacks) {
      var tmpArray = []
      var tmpStarpacks = []
      starpacks.forEach(starpack => {
        if (!disableStarpacks.includes(starpack.id_starpack)) {
          var counter = 1
          starpack?.result_info?.main_products.forEach(main_product => {
            switch (main_product.code) {
              case 'KA':
                counter++
                break
              default:
                break
            }
          })
          if (counter === 2) {
            tmpArray.push(starpack)
          }
        }
      })

      tmpArray.forEach(element => {
        element?.result_info?.main_products.forEach(main_product => {
          main_product.subcategories.forEach(subcategory => {
            if (subcategory.code === 'SUM' && main_product.code === 'LA') {
              if (subcategory.value % 1 === 0 && subcategory.value >= 600000) {
                tmpStarpacks.push(element)
              }
            }
          })
        })
      })

      tmpStarpacks.sort(function (a, b) {
        return parseFloat(a.price) - parseFloat(b.price)
      })

      return tmpStarpacks.length > 0 ? tmpStarpacks[0] : false
    },
    filterMainProducts (main_products, type) {
      var tmpArray = { odd: [], even: [] }
      main_products.forEach(element => {
        var number = 'odd'
        if (parseInt(element.sort) % 2 == 0) {
          number = 'even'
        }
        tmpArray[number].push({
          code: element.code,
          sort: element.sort,
          name: element.name,
          subcategories: element.subcategories
        })
      })

      if (tmpArray[type] && tmpArray[type].length > 0) {
        tmpArray[type].sort(function (a, b) {
          return parseInt(a.sort) - parseInt(b.sort)
        })
        return tmpArray[type]
      }
    },
    filterSubcategories (subcategories) {
      var tmpArray = []
      subcategories.forEach(element => {
        var value_sum = ''
        if (element.value) {
          value_sum = element.value
          if (element.code === 'SUM') {
            value_sum = this.formatPrice(element.value)
          }
          tmpArray.push({
            code: element.code,
            sort: element.sort,
            name: element.name,
            value: value_sum === '1' ? 'TAK' : value_sum
          })
        }
      })
      tmpArray.sort(function (a, b) {
        return parseInt(a.sort) - parseInt(b.sort)
      })

      return tmpArray
    },
    filterAdditionalPackages (range_offer) {
      let tmpKey = []
      let additionalPackages = []
      this.mainPackages.forEach(element => {
        tmpKey.push(element.key)
      })
      range_offer.forEach(packageOffer => {
        if (!tmpKey.includes(packageOffer.name)) {
          additionalPackages.push(packageOffer)
        }
      })
      return additionalPackages
    },
    getObjKey (obj, value) {
      return Object.keys(obj).find(key => obj[key] === value)
    },

    getAddresses (item, podium) {
      let _this = this
      _this.$store.commit('setStarpack', item)
      this.formatStarpackEvent(item, podium)
      if(_this.$store.state.starpackEvent && this.$store.state.starpackEvent.brand){
        this.updateLead()
      }

      this.$router.push('/form-step-3')
    },
    updateLead () {
      let _this = this
      let insurer = _this.$store.state.starpackEvent.brand
      switch (insurer) {
        case "AXA":
          insurer = "AXA Direct"
          break;
        case "Europ Assistance":
          insurer = "Europ"
          break;
      }
      this.axios
        .post('/wp-json/travel/v1/updateLead', {
          lead: {
            salesforce_id: _this.$store.state.leadSalesforceId,
            calculation_token: _this.$store.state.calculationToken,
            insurer: insurer
          }
        })
        .catch(function (error) {
          console.log(error)
          // _this.$store.commit('setShowModal', true)
        })
    },
    setActive (event) {
      // this.showDetails = !this.showDetails
      event.target.closest('.show-details').classList.toggle('toggle')
      event.target
        .closest('.show-details')
        .parentNode.nextElementSibling.classList.toggle('hidden')
    },
    replacePrice (price) {
      return price.toString().replace('.', ',')
    },
    getTreatmentAndAssistance (main_products) {
      var price = false
      main_products.forEach(main_product => {
        if (
          main_product.code == 'Leczenie i assistance' &&
          main_product.subcategories
        ) {
          main_product.subcategories.forEach(subcategory => {
            if (subcategory.code == 'leczenie i assistance') {
              price = subcategory.value
            }
          })
        }
      })
      return price
    },
    formatStarpacksEvent (starpacks) {
      var tmp = []
      starpacks.forEach((element, index) => {
        tmp.push({
          name: 'Oferta nr.: ' + element.id_starpack, //nazwa oferty
          id: element.id_starpack, //id oferty
          price: element.price, //cena
          brand: element?.result_info?.name, //nazwa ubezpieczalni
          category: 'Insurance/Travel', //stała
          variant: 'Travel', //stała
          list: 'Travel Search Results', //stała
          position: index + 1 //pozycja na liście ofert
        })
      })

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ ecommerce: null })
      window.dataLayer.push({
        event: 'travelInsuranceCalculator',
        action: 'ecommerce',
        label: 'impressions',
        ecommerce: {
          currencyCode: 'PLN',
          impressions: tmp
        }
      })

      this.$store.commit('setStarpacksEvent', tmp)
    },
    formatStarpackEvent (item, podium) {
      var list = 'Travel Search Results' //stała
      this.$store.state.starpacksEvent.forEach(starpack => {
        if (starpack.id === item.id_starpack) {
          this.$store.commit('setStarpackEvent', starpack)
        }
      })
      if(podium){
        list = 'Travel Search Results Recommended'
      }

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ ecommerce: null })
      window.dataLayer.push({
        event: 'travelInsuranceCalculator', //stała
        action: 'ecommerce', //stała
        label: 'productClick', //stała
        ecommerce: {
          click: {
            actionField: {
              list: list
            },
            products: [this.$store.state.starpackEvent]
          }
        }
      })
    }
  }
}
</script>
